import { PAYMENT_STATUS, STATUS } from 'domains/customer-order/constants'

const OrderService = {
  isPaymentCreatable: (order) => {
    const payCreatableReducer = (isPayCreatable, payment) => {
      const isCurrentCreatable = (
        payment?.status === PAYMENT_STATUS.EXPIRED ||
        payment?.status === PAYMENT_STATUS.CANCELLED ||
        payment?.status === PAYMENT_STATUS.FAILED
      )
      return isPayCreatable && isCurrentCreatable
    }
    // set true since we using &&
    const paymentResult = order?.payments?.reduce(payCreatableReducer, true)

    return paymentResult && order.status === STATUS.PENDING
  }
}

export default OrderService
